export const REGULAR_FAVICON = '/assets/images/favicon.ico';

export const FAVICON_FRAMES = [REGULAR_FAVICON];
export const FAVICON_ANIMATION_DELAY = 250;
